module.exports = __webpack_public_path__ + "img/moon.4a95fc1e.svg";